export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
    TIMEOUT: 100000,
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development'
};